<div *ngIf="heeftOndernemingen()">
    <form [formGroup]="ondernemingFG">
        <div formArrayName="ondernemingen">
            <div *ngFor="let onderneming of ondernemingen.controls; let i = index "
                 [formGroupName]="i">
                <div formArrayName="investeringen">
                    <div *ngFor="let wuoGroup of getInvesteringen(i).controls; let c = index "
                         [formGroupName]="c" class="row">
                        <snelstart-ui-text-form-control (change)="saveForm()"
                                                        [attr.disabled]="true"
                                                        [label]="c === 0 ? 'Omschrijving' : ''"
                                                        [required]=true
                                                        class="custom-input-250"
                                                        formControlName="omschrijving"
                                                        id="omschrijving"
                        >
                        </snelstart-ui-text-form-control>
                        <snelstart-ui-select-form-control (change)="saveForm()"
                                                          [label]="c === 0 ? 'Recht op KIA?' : ''"
                                                          [options]="optionsJaNee"
                                                          class="custom-input-125"
                                                          formControlName="claimKIA"
                                                          id="claimEKIA-{{i}}"
                        >
                        </snelstart-ui-select-form-control>
                        <snelstart-ui-select-form-control (change)="saveForm()"
                                                          [label]="c === 0 ? 'Recht op EIA?' : ''"
                                                          [options]="optionsJaNee"
                                                          class="custom-input-125"
                                                          formControlName="claimEIA"
                                                          id="claimEIA-{{i}}"
                        >
                        </snelstart-ui-select-form-control>
                        <snelstart-ui-select-form-control (change)="saveForm()"
                                                          [label]="c === 0 ? 'Recht op MIA?' : ''"
                                                          [options]="optionsJaNee"
                                                          class="custom-input-125"
                                                          formControlName="claimMIA"
                                                          id="claimMIA-{{i}}"
                        >
                        </snelstart-ui-select-form-control>
                        <div *ngIf="wuoGroup.value.claimKIA || wuoGroup.value.claimEIA || wuoGroup.value.claimMIA"
                             class="row col-auto">
                            <snelstart-ui-button
                                    (click)="this.showDialog(c)"
                                    [class]="c === 0 ? 'me-1 pt-3 custom-input-150' : 'me-1 custom-input-150'"
                                    icon="plus"
                                    type="secondary">
                                Gegevens
                            </snelstart-ui-button>
                        </div>
                        <div *ngIf="!wuoGroup.value.claimKIA && !wuoGroup.value.claimEIA && !wuoGroup.value.claimMIA"
                             class="row col-auto">
                            <snelstart-ui-button
                                    [class]="c === 0 ? 'me-1 pt-3 custom-input-150' : 'me-1 custom-input-150'"
                                    [disabled]="true"
                                    icon="plus"
                                    type="secondary">
                                Gegevens
                            </snelstart-ui-button>
                        </div>

                        <div *ngIf="wuoGroup.value.claimKIA || wuoGroup.value.claimEIA || wuoGroup.value.claimMIA"
                             class="row col-auto">
                            <snelstart-ui-number-form-control (change)="saveForm()"
                                                              [decimals]="0"
                                                              [label]="c === 0 ? 'Desinvestering' : ''"
                                                              align="right"
                                                              class="custom-input-150"
                                                              formControlName="grondslagDesinvestering"
                                                              id="grondslagDesinvestering-{{i}}"
                                                              prefix="€"
                            >
                            </snelstart-ui-number-form-control>
                            <snelstart-ui-number-form-control
                                    (change)="saveForm()"
                                    [label]="c === 0 ? '% Desinv.bijt.' : ''"
                                    [showAllDecimals]="true"
                                    align="right"
                                    class="me-1 custom-input-125"
                                    formControlName="percentageInvesteringsaftrek"
                                    id="percentageInvesteringsaftrek-{{i}}"
                                    placeholder="n.v.t."
                                    prefix="%">
                            </snelstart-ui-number-form-control>
                        </div>
                        <div *ngIf="!wuoGroup.value.claimKIA && !wuoGroup.value.claimEIA && !wuoGroup.value.claimMIA"
                             class="row col-auto">
                            <snelstart-ui-number-form-control (change)="saveForm()"
                                                              [decimals]="0"
                                                              [label]="c === 0 ? 'Desinvestering' : ''"
                                                              align="right"
                                                              class="custom-input-150"
                                                              formControlName="grondslagDesinvestering"
                                                              id="grondslagDesinvestering-{{i}}"
                                                              prefix="€"
                            >
                            </snelstart-ui-number-form-control>
                            <snelstart-ui-number-form-control
                                    (change)="saveForm()"
                                    [label]="c === 0 ? '% Desinv.bijt.' : ''"
                                    [showAllDecimals]="true"
                                    align="right"
                                    class="me-1 custom-input-125"
                                    formControlName="percentageInvesteringsaftrek"
                                    id="percentageInvesteringsaftrek-{{i}}"
                                    prefix="%">
                            </snelstart-ui-number-form-control>
                        </div>
                        <snelstart-ui-button (click)="deleteInvesteringen(i, c)"
                                             [class]="c === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                             icon="trash"
                                             iconType="light"
                                             id="buttonDeleteInv"
                                             size="medium"
                                             type="secondary"
                        >
                        </snelstart-ui-button>
                    </div>
                </div>
                <div>
                    <div *ngIf="getInvesteringen(i).length === 0">
                        <snelstart-ui-button (click)="addInvesteringen(i)" class="snelstart-ui-button pb-3"
                                             icon="plus"
                                             type="link">(Des)Investeringen invullen
                        </snelstart-ui-button>
                    </div>
                    <div *ngIf="getInvesteringen(i).length > 0">
                        <snelstart-ui-button (click)="addInvesteringen(i)" class="snelstart-ui-button pb-3"
                                             icon="plus"
                                             type="link">(Des)Investeringen toevoegen
                        </snelstart-ui-button>
                    </div>
                </div>
                @if ((ondernemingen.controls[i].get('ondernemingsvorm')?.value === 'VOF' ||
                    ondernemingen.controls[i].get('ondernemingsvorm')?.value === 'MAATSCHAP') && getInvesteringen(i).length > 0) {
                    <snelstart-ui-alert type="warning">
                        Er is sprake van een samenwerkingsverband. Vul de investeringen voor het samenwerkingsverband en
                        geef aan welk aandeel in het investeringsbedrag voor aangever is.<br/>
                        Bij een buitenvennootschappelijke investering is het aandeel in de investering gelijk aan het
                        investeringsbedrag.

                    </snelstart-ui-alert>
                }

            </div>
        </div>
    </form>
</div>

<snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="wuoBijzonderheden" size="lg"
                                title="Specificatie investering">
    <snelstart-ui-dialog-body>
        <form [formGroup]="ondernemingFG">
            <div formArrayName="ondernemingen">
                <div
                        *ngFor="let onderneming of ondernemingen.controls; let i = index "
                        [formGroupName]="i">
                    <div formArrayName="investeringen">
                        <div
                                *ngFor="let wuoGroup of getInvesteringen(i).controls; let c = index; "
                                [formGroupName]="c">
                            <div *ngIf="c === this.index">
                                <div>
                                    <snelstart-ui-date-form-control (change)="saveForm()"
                                                                    class="me-1 custom-input-200"
                                                                    formControlName="datumIngebruikname"
                                                                    id="datumIngebruikname"
                                                                    label="Datum ingebruikname"
                                                                    placeholder="dd-mm-jjjj"
                                    >
                                    </snelstart-ui-date-form-control>
                                </div>
                                <div *ngIf="wuoGroup.value.claimKIA">
                                    <div>
                                        <snelstart-ui-number-form-control
                                                (change)="saveForm()"
                                                [decimals]="0"
                                                align="right"
                                                class="me-1 custom-input-200"
                                                formControlName="investeringsbedragKIA"
                                                id="investeringsbedragKIA-{{i}}"
                                                label="Investeringsbedrag voor de KIA"
                                                prefix="€"
                                        >
                                        </snelstart-ui-number-form-control>
                                        @if (ondernemingen.controls[i].get('ondernemingsvorm')?.value === 'VOF' ||
                                        ondernemingen.controls[i].get('ondernemingsvorm')?.value === 'MAATSCHAP') {
                                            <snelstart-ui-number-form-control
                                                    (change)="saveForm()"
                                                    [decimals]="0"
                                                    align="right"
                                                    class="me-1 custom-input-200"
                                                    formControlName="aandeelInInvesteringsBedrag"
                                                    label="Aandeel in investeringsbedrag"
                                                    prefix="€"
                                            >
                                            </snelstart-ui-number-form-control>
                                        }

                                    </div>
                                </div>
                                <div *ngIf="wuoGroup.value.claimEIA">
                                    <div>
                                        <snelstart-ui-number-form-control
                                                (change)="saveForm()"
                                                [decimals]="0"
                                                align="right"
                                                class="me-1 custom-input-200"
                                                formControlName="investeringsbedragEIA"
                                                label="Investeringsbedrag voor de EIA"
                                                prefix="€"
                                        >
                                        </snelstart-ui-number-form-control>
                                        <snelstart-ui-text-form-control class="me-1 custom-input-200"
                                                                        formControlName="meldingsNummerEia"
                                                                        label="Meldingsnummer EIA"
                                        >
                                        </snelstart-ui-text-form-control>
                                    </div>
                                </div>
                                <div *ngIf="wuoGroup.value.claimMIA">
                                    <div>
                                        <snelstart-ui-number-form-control
                                                (change)="saveForm()"
                                                [decimals]="0"
                                                align="right"
                                                class="me-1 custom-input-200"
                                                formControlName="investeringsbedragMIA"
                                                label="Investeringsbedrag voor de MIA"
                                                prefix="€"
                                        >
                                        </snelstart-ui-number-form-control>
                                        <snelstart-ui-text-form-control (change)="saveForm()"
                                                                        class="me-1 custom-input-200"
                                                                        formControlName="meldingsNummerMia"
                                                                        label="Meldingsnummer MIA"
                                        >
                                        </snelstart-ui-text-form-control>
                                        <snelstart-ui-select-form-control (change)="saveForm()"
                                                                          [options]="miaLetter"
                                                                          class="me-1 custom-input-200"
                                                                          formControlName="miaLetter"
                                                                          label="Meldingsletter"
                                        >
                                        </snelstart-ui-select-form-control>
                                    </div>
                                </div>
                                <div>
                                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                                      [decimals]="0"
                                                                      align="right"
                                                                      class="me-1 custom-input-200"
                                                                      formControlName="reedsBetaaldDoorAangever"
                                                                      label="Al betaald in boekjaar"
                                                                      prefix="€"
                                    >
                                    </snelstart-ui-number-form-control>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons class="d-flex mt-2">
        <snelstart-ui-button btn-x class="me-2" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
        <snelstart-ui-button icon="check" id="save" type="primary">Akkoord</snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>

<div *ngIf="!heeftOndernemingen()">
    <div *ngIf="!partnerBoolean">
        Er is geen onderneming voor {{ this.dataService.naamAangever }} ingevuld.
    </div>

    <div *ngIf="partnerBoolean">
        Er is geen onderneming voor {{ this.dataService.naamPartner }} ingevuld.
    </div>
</div>
